@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint


object GetPassengerRideDetailsEndpoint : EndPoint<GetPassengerRideDetailsEndpoint.Request, GetPassengerRideDetailsEndpoint.Response>() {


    class Request (
        val rideId: KmmLong
    )

    class Response(
        val passengerRideDto: PassengerRideDto?
    )
}